export function getTimeElapsed(timestamp) {
    const timeNow = new Date();
    const startTime = new Date(timestamp);
    const timeElapsedInSeconds = (timeNow.getTime() - startTime.getTime()) / 1000;
    const hours = Math.floor(timeElapsedInSeconds / 3600);
    const minutes = Math.floor((timeElapsedInSeconds % 3600) / 60);
    const seconds = Math.floor(timeElapsedInSeconds % 60);
    const HH = hours > 0 ? `${addLeadingZero(hours)}:` : '';
    const MM = minutes > 0 ? `${addLeadingZero(minutes)}:` : '00:';
    const SS = addLeadingZero(seconds);
    return `${HH}${MM}${SS}`;
}
function addLeadingZero(value) {
    return value < 10 ? `0${value}` : value;
}
